import React, { useId } from "react";
import "./LeaderboardFlame.css";

// The leaderboard's flame — the one from the leaderboard email, drawn, never
// the 🔥 emoji (founder pick A, build 44). `live` flickers gently (the #1
// row); prefers-reduced-motion keeps it still (LeaderboardFlame.css).
const LeaderboardFlame: React.FC<{ size?: number | string; live?: boolean }> = ({ size = 18, live = false }) => {
  // useId's ":r1:" is not a safe url(#…) fragment everywhere.
  const id = `lbf${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <svg className={`lb-flame${live ? " lb-flame--live" : ""}`} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#ff4d00" />
          <stop offset="0.55" stopColor="#ff9a1f" />
          <stop offset="1" stopColor="#ffd23f" />
        </linearGradient>
      </defs>
      <path
        d="M12 22c-4.1 0-6.9-2.6-6.9-6.3 0-2.7 1.7-4.6 3-6.2C9.5 8 10.5 6.6 10.5 4c2.7 1.3 4.2 3.2 4.4 5.5.6-.5 1-1.3 1.2-2.3 1.7 1.8 2.8 4.1 2.8 6.3 0 3.8-2.8 6.5-6.9 6.5Z"
        fill={`url(#${id})`}
      />
      <path
        d="M12 22c-1.9 0-3.2-1.2-3.2-2.9 0-1.4.8-2.4 1.5-3.2.6-.7 1.1-1.4 1.1-2.7 1.3.7 2.2 1.7 2.3 2.9.4-.2.6-.6.7-1.1.9.9 1.4 2 1.4 3.1 0 2.3-1.7 3.9-3.8 3.9Z"
        fill="#ffe7a3"
        opacity="0.9"
      />
    </svg>
  );
};

export default LeaderboardFlame;
